export const getFormatPhone = (tel: string | undefined | null) => {
  if (!tel) return '';
  if (isNaN(Number(tel))) return tel;

  if (tel.length === 11) {
    if (tel[0] === '8')
      return `+7 (${tel.substring(1, 4)}) ${tel.substring(4, 7)}-${tel.substring(
        7,
        9,
      )}-${tel.substring(9, 11)}`;

    if (tel[0] === '7')
      return `+7 (${tel.substring(1, 4)}) ${tel.substring(4, 7)}-${tel.substring(
        7,
        9,
      )}-${tel.substring(9, 11)}`;
  }
};
